import {writable} from 'svelte/store';

const createStore = () => {
  const {subscribe, set} = writable(false);

  return {
    subscribe,
    set
  };
};

export const sortByMultipleColumnsStore = createStore();
